import { Icon24SkipOneForward } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const StepForwardFrameIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M4.28568 12.8412L4.28568 4.26976"
        stroke="currentColor"
        strokeWidth="0.964286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.42853 12.3157L6.42853 4.79564C6.42935 4.70095 6.45553 4.60822 6.50435 4.52709C6.55318 4.44596 6.62286 4.3794 6.70614 4.33434C6.78942 4.28928 6.88325 4.26737 6.97788 4.27089C7.0725 4.27441 7.16445 4.30322 7.24415 4.35434L13.1497 8.11439C13.2241 8.1615 13.2854 8.22667 13.3279 8.30382C13.3704 8.38098 13.3926 8.46761 13.3926 8.55568C13.3926 8.64375 13.3704 8.73039 13.3279 8.80755C13.2854 8.8847 13.2241 8.94986 13.1497 8.99698L7.24415 12.757C7.16445 12.8081 7.0725 12.837 6.97788 12.8405C6.88325 12.844 6.78942 12.8221 6.70614 12.777C6.62286 12.732 6.55318 12.6654 6.50435 12.5843C6.45553 12.5031 6.42935 12.4104 6.42853 12.3157Z"
        stroke="currentColor"
        strokeWidth="0.964286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StepForwardFrameIcon = fplIcon(StepForwardFrameIconLocal, Icon24SkipOneForward);
